import type { LegalCopy } from '../types'

export const pa: LegalCopy = {
  title: 'ਕਾਨੂੰਨੀ ਮਦਦ',
  subtitle: 'ਆਮ ਕਾਨੂੰਨੀ ਮੁਸ਼ਕਲਾਂ, ਸੌਖੇ ਸ਼ਬਦਾਂ ਵਿੱਚ। ਆਪਣੀ ਭਾਸ਼ਾ ਵਿੱਚ ਸੁਣੋ, ਅਤੇ ਹਰ ਜਵਾਬ ਦਾ ਸਰਕਾਰੀ ਸਰੋਤ ਵੇਖੋ।',
  helplinesTitle: 'ਹੈਲਪਲਾਈਨ (ਮੁਫ਼ਤ ਕਾਲ)',
  helplines: {
    emergency: 'ਐਮਰਜੈਂਸੀ: ਪੁਲਿਸ, ਫ਼ਾਇਰ, ਐਂਬੂਲੈਂਸ',
    legal_aid: 'ਮੁਫ਼ਤ ਕਾਨੂੰਨੀ ਮਦਦ (NALSA)',
    cyber: 'ਆਨਲਾਈਨ / UPI ਧੋਖਾਧੜੀ',
    women: 'ਮਹਿਲਾ ਹੈਲਪਲਾਈਨ',
    consumer: 'ਖਪਤਕਾਰ ਹੈਲਪਲਾਈਨ'
  },
  faqTitle: 'ਆਮ ਸਵਾਲ',
  searchPlaceholder: 'ਖੋਜੋ: FIR, ਧੋਖਾਧੜੀ, RTI, ਵਕੀਲ…',
  noMatch: 'ਕੋਈ ਸਵਾਲ ਨਹੀਂ ਮਿਲਿਆ। ਹੇਠਾਂ ਆਪਣਾ ਸਵਾਲ ਪੁੱਛੋ।',
  sources: 'ਸਰਕਾਰੀ ਸਰੋਤ',
  listen: 'ਸੁਣੋ',
  askTitle: 'ਆਪਣਾ ਕਾਨੂੰਨੀ ਸਵਾਲ ਪੁੱਛੋ',
  askHint: 'ਸਮਝੋ ਸਿਰਫ਼ ਸਰਕਾਰੀ ਵੈੱਬਸਾਈਟਾਂ ਤੋਂ ਹੀ ਜਵਾਬ ਦਿੰਦਾ ਹੈ, ਸਰੋਤ ਦੇ ਲਿੰਕ ਨਾਲ।',
  starters: ['ਕੀ ਮੈਨੂੰ ਮੁਫ਼ਤ ਵਕੀਲ ਮਿਲ ਸਕਦਾ ਹੈ?', 'ਕਿਸੇ ਨੇ ਮੇਰੇ ਨਾਲ ਆਨਲਾਈਨ ਧੋਖਾ ਕੀਤਾ। ਮੈਂ ਕੀ ਕਰਾਂ?', 'ਪੁਲਿਸ ਮੇਰੀ ਸ਼ਿਕਾਇਤ ਨਹੀਂ ਲਿਖ ਰਹੀ। ਮੈਂ ਕੀ ਕਰ ਸਕਦਾ ਹਾਂ?'],
  disclaimer:
    'ਇਹ ਸਰਕਾਰੀ ਸਰੋਤਾਂ ਤੋਂ ਲਈ ਗਈ ਆਮ ਜਾਣਕਾਰੀ ਹੈ, ਤੁਹਾਡੇ ਕੇਸ ਲਈ ਕਾਨੂੰਨੀ ਸਲਾਹ ਨਹੀਂ। ਆਪਣੇ ਕੇਸ ਲਈ ਵਕੀਲ ਨਾਲ ਗੱਲ ਕਰੋ — ਕਾਨੂੰਨੀ ਸੇਵਾਵਾਂ ਅਥਾਰਟੀ (15100) ਤੋਂ ਤੁਹਾਨੂੰ ਮੁਫ਼ਤ ਵਕੀਲ ਮਿਲ ਸਕਦਾ ਹੈ।',
  topics: {
    get_free_aid: {
      q: 'ਮੁਫ਼ਤ ਕਾਨੂੰਨੀ ਮਦਦ ਕਿਵੇਂ ਮਿਲੇਗੀ?',
      a: 'NALSA ਦੀ ਮੁਫ਼ਤ ਹੈਲਪਲਾਈਨ 15100 ’ਤੇ ਕਾਲ ਕਰੋ। ਜਾਂ ਆਪਣੀ ਜ਼ਿਲ੍ਹਾ ਅਦਾਲਤ ਵਿੱਚ ਕਾਨੂੰਨੀ ਸੇਵਾਵਾਂ ਅਥਾਰਟੀ ਦੇ ਦਫ਼ਤਰ, ਜਾਂ ਤਹਿਸੀਲ (ਤਾਲੁਕਾ) ਅਦਾਲਤ ਵਿੱਚ ਕਾਨੂੰਨੀ ਸੇਵਾਵਾਂ ਕਮੇਟੀ ਕੋਲ ਜਾਓ। ਤੁਸੀਂ ਆਨਲਾਈਨ, ਡਾਕ ਰਾਹੀਂ ਜਾਂ ਈ-ਮੇਲ ਰਾਹੀਂ ਵੀ ਅਰਜ਼ੀ ਦੇ ਸਕਦੇ ਹੋ। ਫ਼ਾਰਮ ਮੁਫ਼ਤ ਹੈ, ਅਤੇ ਵਕੀਲ ਦੀ ਫ਼ੀਸ ਅਤੇ ਅਦਾਲਤ ਦਾ ਖ਼ਰਚਾ ਤੁਹਾਡੇ ਲਈ ਭਰਿਆ ਜਾਂਦਾ ਹੈ।'
    },
    who_free_aid: {
      q: 'ਮੁਫ਼ਤ ਵਕੀਲ ਕਿਸ ਨੂੰ ਮਿਲ ਸਕਦਾ ਹੈ?',
      a: 'ਕਾਨੂੰਨ (ਕਾਨੂੰਨੀ ਸੇਵਾਵਾਂ ਅਥਾਰਟੀਆਂ ਐਕਟ ਦੀ ਧਾਰਾ 12) ਇਹਨਾਂ ਨੂੰ ਮੁਫ਼ਤ ਕਾਨੂੰਨੀ ਮਦਦ ਦਿੰਦਾ ਹੈ: ਔਰਤਾਂ ਅਤੇ ਬੱਚੇ, SC/ST ਦੇ ਲੋਕ, ਦਿਵਿਆਂਗ ਵਿਅਕਤੀ, ਉਦਯੋਗਿਕ ਮਜ਼ਦੂਰ, ਮਨੁੱਖੀ ਤਸਕਰੀ ਜਾਂ ਬੇਗਾਰ (ਜਬਰੀ ਮਜ਼ਦੂਰੀ) ਦੇ ਸ਼ਿਕਾਰ, ਆਫ਼ਤ, ਜਾਤੀ ਅੱਤਿਆਚਾਰ ਜਾਂ ਨਸਲੀ ਹਿੰਸਾ ਦੇ ਸ਼ਿਕਾਰ, ਹਿਰਾਸਤ ਵਿੱਚ ਰੱਖੇ ਲੋਕ, ਅਤੇ ਉਹ ਲੋਕ ਜਿਨ੍ਹਾਂ ਦੀ ਸਾਲਾਨਾ ਆਮਦਨ ਉਹਨਾਂ ਦੇ ਰਾਜ ਵੱਲੋਂ ਤੈਅ ਹੱਦ ਤੋਂ ਘੱਟ ਹੈ। ਆਮਦਨ ਦੀ ਹੱਦ ਹਰ ਰਾਜ ਵਿੱਚ ਵੱਖਰੀ ਹੈ।'
    },
    fir: {
      q: 'ਪੁਲਿਸ ਮੇਰੀ FIR ਦਰਜ ਨਹੀਂ ਕਰ ਰਹੀ। ਮੈਂ ਕੀ ਕਰਾਂ?',
      a: 'ਗੰਭੀਰ (ਕਾਬਲ-ਏ-ਦਸਤ-ਅੰਦਾਜ਼ੀ) ਅਪਰਾਧ ਦੀ ਰਿਪੋਰਟ ਤੁਸੀਂ ਕਿਸੇ ਵੀ ਥਾਣੇ ਵਿੱਚ ਕਰ ਸਕਦੇ ਹੋ, ਭਾਵੇਂ ਅਪਰਾਧ ਕਿਤੇ ਹੋਰ ਹੋਇਆ ਹੋਵੇ — ਇਸ ਨੂੰ ਜ਼ੀਰੋ FIR ਕਹਿੰਦੇ ਹਨ। ਪੁਲਿਸ ਨੂੰ ਤੁਹਾਨੂੰ FIR ਦੀ ਕਾਪੀ ਮੁਫ਼ਤ ਦੇਣੀ ਪੈਂਦੀ ਹੈ। ਜੇ ਪੁਲਿਸ ਮਨ੍ਹਾ ਕਰੇ, ਤਾਂ ਆਪਣੀ ਸ਼ਿਕਾਇਤ ਲਿਖ ਕੇ ਡਾਕ ਰਾਹੀਂ ਪੁਲਿਸ ਸੁਪਰਡੈਂਟ (SP) ਨੂੰ ਭੇਜੋ। ਜੇ SP ਵੀ ਕੁਝ ਨਾ ਕਰੇ, ਤਾਂ ਤੁਸੀਂ ਹਲਫ਼ਨਾਮੇ ਨਾਲ ਮੈਜਿਸਟ੍ਰੇਟ ਕੋਲ ਅਰਜ਼ੀ ਦੇ ਸਕਦੇ ਹੋ।'
    },
    cyber_fraud: {
      q: 'ਆਨਲਾਈਨ ਜਾਂ UPI ਧੋਖਾਧੜੀ ਵਿੱਚ ਮੇਰੇ ਪੈਸੇ ਚਲੇ ਗਏ। ਮੈਂ ਕੀ ਕਰਾਂ?',
      a: 'ਤੁਰੰਤ 1930 ’ਤੇ ਕਾਲ ਕਰੋ — ਇਹ ਰਾਸ਼ਟਰੀ ਸਾਈਬਰ ਕ੍ਰਾਈਮ ਹੈਲਪਲਾਈਨ ਹੈ, ਮੁਫ਼ਤ ਹੈ ਅਤੇ ਦਿਨ-ਰਾਤ ਚੱਲਦੀ ਹੈ। ਜਲਦੀ ਦੱਸਣ ਨਾਲ ਪੈਸੇ ਨੂੰ ਅੱਗੇ ਭੇਜੇ ਜਾਣ ਤੋਂ ਰੋਕਣ ਵਿੱਚ ਮਦਦ ਮਿਲਦੀ ਹੈ। ਨਾਲ ਹੀ cybercrime.gov.in ’ਤੇ “Financial Fraud” ਵਿੱਚ ਸ਼ਿਕਾਇਤ ਦਰਜ ਕਰੋ।'
    },
    women: {
      q: 'ਕੋਈ ਔਰਤ ਹਿੰਸਾ ਜਾਂ ਤੰਗ-ਪਰੇਸ਼ਾਨੀ ਝੱਲ ਰਹੀ ਹੈ। ਉਸ ਨੂੰ ਮਦਦ ਕਿੱਥੋਂ ਮਿਲੇਗੀ?',
      a: 'ਐਮਰਜੈਂਸੀ ਵਿੱਚ ਪੁਲਿਸ, ਫ਼ਾਇਰ ਜਾਂ ਐਂਬੂਲੈਂਸ ਲਈ 112 ਮਿਲਾਓ। ਮੁਫ਼ਤ ਮਹਿਲਾ ਹੈਲਪਲਾਈਨ 181 ’ਤੇ ਦਿਨ-ਰਾਤ ਕਦੇ ਵੀ ਕਾਲ ਕਰੋ। ਤੁਸੀਂ ਆਪਣਾ ਨਾਂ ਲੁਕਾ ਕੇ ਰੱਖ ਸਕਦੇ ਹੋ, ਅਤੇ ਇਹ ਹੈਲਪਲਾਈਨ ਤੁਹਾਨੂੰ ਪੁਲਿਸ, ਵਨ ਸਟਾਪ ਸੈਂਟਰ, ਹਸਪਤਾਲ ਜਾਂ ਕਾਨੂੰਨੀ ਮਦਦ ਨਾਲ ਜੋੜਦੀ ਹੈ। ਰਾਸ਼ਟਰੀ ਮਹਿਲਾ ਕਮਿਸ਼ਨ ਦੀ ਹੈਲਪਲਾਈਨ 14490 ਵੀ ਹੈ, ਅਤੇ ਕਮਿਸ਼ਨ ਆਨਲਾਈਨ ਸ਼ਿਕਾਇਤਾਂ ਵੀ ਲੈਂਦਾ ਹੈ।'
    },
    consumer: {
      q: 'ਕਿਸੇ ਦੁਕਾਨ ਜਾਂ ਕੰਪਨੀ ਨੇ ਮੇਰੇ ਨਾਲ ਠੱਗੀ ਕੀਤੀ। ਸ਼ਿਕਾਇਤ ਕਿੱਥੇ ਕਰਾਂ?',
      a: 'ਰਾਸ਼ਟਰੀ ਖਪਤਕਾਰ ਹੈਲਪਲਾਈਨ 1915 ’ਤੇ ਕਾਲ ਕਰੋ (ਮੁਫ਼ਤ, ਸਵੇਰੇ 8 ਤੋਂ ਰਾਤ 8 ਵਜੇ ਤੱਕ), 8800001915 ’ਤੇ WhatsApp ਸੁਨੇਹਾ ਭੇਜੋ, ਜਾਂ consumerhelpline.gov.in ’ਤੇ ਸ਼ਿਕਾਇਤ ਕਰੋ। ਖਪਤਕਾਰ ਕਮਿਸ਼ਨ ਵਿੱਚ ਕੇਸ ਕਰਨਾ ਹੋਵੇ, ਤਾਂ e-Daakhil ’ਤੇ ਆਨਲਾਈਨ ਕਰ ਸਕਦੇ ਹੋ।'
    },
    summons: {
      q: 'ਮੈਨੂੰ ਅਦਾਲਤ ਦਾ ਸੰਮਨ ਮਿਲਿਆ ਹੈ। ਮੈਂ ਕੀ ਕਰਾਂ?',
      a: 'ਸੰਮਨ ਵਿੱਚ ਲਿਖਿਆ ਹੁੰਦਾ ਹੈ ਕਿ ਤੁਸੀਂ ਕਿਸ ਤਾਰੀਖ਼ ਨੂੰ ਅਦਾਲਤ ਆਉਣਾ ਹੈ। ਜੇ ਤੁਸੀਂ ਯੋਗ ਹੋ, ਤਾਂ ਕੇਸ ਦੇ ਕਿਸੇ ਵੀ ਪੜਾਅ ’ਤੇ ਮੁਫ਼ਤ ਵਕੀਲ ਮਿਲ ਸਕਦਾ ਹੈ: 15100 ’ਤੇ ਕਾਲ ਕਰੋ ਜਾਂ ਆਪਣੀ ਜ਼ਿਲ੍ਹਾ ਅਦਾਲਤ ਵਿੱਚ ਕਾਨੂੰਨੀ ਸੇਵਾਵਾਂ ਦੇ ਦਫ਼ਤਰ ਜਾਓ। ਆਪਣਾ ਕੇਸ ਅਤੇ ਅਗਲੀ ਤਾਰੀਖ਼ eCourts ਵੈੱਬਸਾਈਟ ਜਾਂ ਐਪ ’ਤੇ ਵੇਖ ਸਕਦੇ ਹੋ।'
    },
    case_status: {
      q: 'ਆਪਣੇ ਅਦਾਲਤੀ ਕੇਸ ਦਾ ਸਟੇਟਸ ਕਿਵੇਂ ਵੇਖਾਂ?',
      a: 'services.ecourts.gov.in ’ਤੇ ਜਾਓ, ਜਾਂ eCourts Services ਐਪ ਵਰਤੋ, ਅਤੇ ਆਪਣੇ 16-ਅੰਕਾਂ ਵਾਲੇ CNR ਨੰਬਰ ਜਾਂ ਕੇਸ ਦੀ ਹੋਰ ਜਾਣਕਾਰੀ ਨਾਲ ਖੋਜੋ। SMS ਵੀ ਕਰ ਸਕਦੇ ਹੋ: ECOURTS, ਫਿਰ ਇੱਕ ਸਪੇਸ, ਫਿਰ ਆਪਣਾ CNR ਨੰਬਰ ਲਿਖ ਕੇ 9766899899 ’ਤੇ ਭੇਜੋ।'
    },
    lok_adalat: {
      q: 'ਲੋਕ ਅਦਾਲਤ ਕੀ ਹੈ?',
      a: 'ਲੋਕ ਅਦਾਲਤ ਦੋਵਾਂ ਧਿਰਾਂ ਦੀ ਸਹਿਮਤੀ ਨਾਲ ਕੇਸ ਨਿਪਟਾਉਂਦੀ ਹੈ। ਇਸ ਵਿੱਚ ਕੋਈ ਅਦਾਲਤੀ ਫ਼ੀਸ ਨਹੀਂ ਲੱਗਦੀ, ਅਤੇ ਜੇ ਅਦਾਲਤ ਵਿੱਚ ਚੱਲ ਰਿਹਾ ਕੇਸ ਇੱਥੇ ਨਿਪਟ ਜਾਵੇ, ਤਾਂ ਭਰੀ ਹੋਈ ਅਦਾਲਤੀ ਫ਼ੀਸ ਵਾਪਸ ਮਿਲ ਜਾਂਦੀ ਹੈ। ਇਸ ਦਾ ਫ਼ੈਸਲਾ ਅਦਾਲਤ ਦੀ ਡਿਗਰੀ ਵਾਂਗ ਅੰਤਿਮ ਹੁੰਦਾ ਹੈ ਅਤੇ ਦੋਵਾਂ ਧਿਰਾਂ ਨੂੰ ਮੰਨਣਾ ਪੈਂਦਾ ਹੈ, ਅਤੇ ਇਸ ਦੇ ਖ਼ਿਲਾਫ਼ ਅਪੀਲ ਨਹੀਂ ਹੁੰਦੀ।'
    },
    rti: {
      q: 'RTI ਕਿਵੇਂ ਪਾਵਾਂ?',
      a: 'ਕੇਂਦਰ ਸਰਕਾਰ ਦੇ ਦਫ਼ਤਰਾਂ ਲਈ rtionline.gov.in ’ਤੇ ਆਨਲਾਈਨ ਅਰਜ਼ੀ ਦਿਓ। ਫ਼ੀਸ ₹10 ਹੈ; ਜੇ ਤੁਸੀਂ ਗ਼ਰੀਬੀ ਰੇਖਾ ਤੋਂ ਹੇਠਾਂ (BPL) ਹੋ ਤਾਂ ਕੋਈ ਫ਼ੀਸ ਨਹੀਂ (ਆਪਣਾ BPL ਸਰਟੀਫ਼ਿਕੇਟ ਨਾਲ ਲਾਓ)। ਅਧਿਕਾਰੀ ਨੂੰ 30 ਦਿਨਾਂ ਵਿੱਚ ਜਵਾਬ ਦੇਣਾ ਪੈਂਦਾ ਹੈ, ਅਤੇ ਜੇ ਗੱਲ ਕਿਸੇ ਦੀ ਜਾਨ ਜਾਂ ਆਜ਼ਾਦੀ ਦੀ ਹੋਵੇ ਤਾਂ 48 ਘੰਟਿਆਂ ਵਿੱਚ। ਜੇ 30 ਦਿਨਾਂ ਵਿੱਚ ਜਵਾਬ ਨਾ ਮਿਲੇ, ਤਾਂ ਅਗਲੇ 30 ਦਿਨਾਂ ਵਿੱਚ ਮੁਫ਼ਤ ਪਹਿਲੀ ਅਪੀਲ ਕਰ ਸਕਦੇ ਹੋ।'
    },
    grievance: {
      q: 'ਸਰਕਾਰੀ ਦਫ਼ਤਰ ਮੇਰਾ ਕੰਮ ਨਹੀਂ ਕਰ ਰਿਹਾ। ਸ਼ਿਕਾਇਤ ਕਿੱਥੇ ਕਰਾਂ?',
      a: 'pgportal.gov.in ’ਤੇ CPGRAMS ਵਿੱਚ ਸ਼ਿਕਾਇਤ ਦਰਜ ਕਰੋ — ਇਹ ਦਿਨ-ਰਾਤ ਖੁੱਲ੍ਹਾ ਹੈ (ਇਸ ਦੀ ਐਪ ਵੀ ਹੈ, ਅਤੇ ਇਹ UMANG ’ਤੇ ਵੀ ਹੈ)। 21 ਦਿਨਾਂ ਵਿੱਚ ਹੱਲ ਕਰਨ ਦਾ ਟੀਚਾ ਹੈ। ਇਸ ਵਿੱਚ RTI ਦੇ ਮਾਮਲੇ, ਅਦਾਲਤੀ ਕੇਸ, ਧਾਰਮਿਕ ਮਾਮਲੇ ਜਾਂ ਸਰਕਾਰੀ ਮੁਲਾਜ਼ਮਾਂ ਦੇ ਸੇਵਾ ਨਾਲ ਜੁੜੇ ਮਾਮਲੇ ਨਹੀਂ ਲਏ ਜਾਂਦੇ।'
    }
  }
}
